import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MainService } from 'src/app/services/main.service';
import 'bootstrap';
var ClientReportComponent = /** @class */ (function () {
    function ClientReportComponent(route, router, mainService, loader) {
        this.route = route;
        this.router = router;
        this.mainService = mainService;
        this.loader = loader;
        this.language = JSON.parse(localStorage.getItem('language'));
        this.language_flag = localStorage.getItem('language_flag');
        this.disableHeader = false;
        this.pidReq = false;
        this.otpReq = false;
        this.showLogin = true;
        this.requestOTP = false;
        this.showPDPA = false;
        this.otpError = this.language.cs_otp;
        this.loginError = this.language.cs_pid;
        this.consentDesc = [];
        this.consentData = new Map();
        this.loginSeccess = false;
        this.fundList = [];
        this.fundListfilter = [];
        this.HolderNo = [];
        this.typeFundList = ['LTF', 'RMF', 'SSF', 'SSFX', 'TESG'];
        this.select_fund = [];
        this.selectFundList = [];
        this.funListGroup = [];
        this.checkmonth = [
            {
                number: 1,
                name: 'มกราคม',
                nameEn: 'January'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์',
                nameEn: 'February'
            },
            {
                number: 3,
                name: 'มีนาคม',
                nameEn: 'March'
            },
            {
                number: 4,
                name: 'เมษายน',
                nameEn: 'April'
            },
            {
                number: 5,
                name: 'พฤษภาคม',
                nameEn: 'May'
            },
            {
                number: 6,
                name: 'มิถุนายน',
                nameEn: 'June'
            },
            {
                number: 7,
                name: 'กรกฎาคม',
                nameEn: 'July'
            },
            {
                number: 8,
                name: 'สิงหาคม',
                nameEn: 'August'
            },
            {
                number: 9,
                name: 'กันยายน',
                nameEn: 'September'
            },
            {
                number: 10,
                name: 'ตุลาคม',
                nameEn: 'October'
            },
            {
                number: 11,
                name: 'พฤศจิกายน',
                nameEn: 'November'
            },
            {
                number: 12,
                name: 'ธันวาคม',
                nameEn: 'December'
            }
        ];
        this.monthListEN = [];
        this.monthListTH = [];
        this.year101 = [];
        this.isOne = false;
        this.timeLogout = 0;
        this.TimeLogoutDate = 20; //Minutes
        this.timearry = [];
        this.customerNameArry = [];
        // =================================CheckBox============================================================//
        this.checkBoxSelectall = [
            {
                Name: 'Select ALL',
                isChecked: false
            }
        ];
        this.checkBoxList = [
            {
                Name: 'LTF',
                isChecked: false
            },
            {
                Name: 'RMF',
                isChecked: false
            },
            {
                Name: 'SSF',
                isChecked: false
            },
            {
                Name: 'SSFX',
                isChecked: false
            },
            {
                Name: 'ThaiESG',
                isChecked: false
            }
        ];
        this.selectCount = 0;
    }
    ClientReportComponent.prototype.ngOnInit = function () {
        this.loadMyStorage(sessionStorage.getItem("PIDNo"), sessionStorage.getItem("id"), sessionStorage.getItem("AgentID"), JSON.parse(sessionStorage.getItem("TimeLogout")), JSON.parse(sessionStorage.getItem("CType")), parseInt(sessionStorage.getItem("cusid")));
        this.BackOneYear();
        this.getDataCustomer(sessionStorage.getItem('PIDNo'));
        this.backFiveYear();
        // $('#warningModalForClient').modal('show')
        this.timearry = JSON.parse(sessionStorage.getItem("TimeLogout"));
        if (sessionStorage.getItem("LoginSuccess") !== null || sessionStorage.getItem("LoginSuccess") === 'Y') {
            this.checkSevice();
        }
    };
    ClientReportComponent.prototype.checkSevice = function () {
        var _this = this;
        this.route.params.subscribe(function (param) {
            if (_this.AgentID == '1') {
                if (param['id'] === 'DSRR') {
                    _this.openDSAR();
                    _this.router.navigate(['/client-report/', 'ED']);
                }
                else if (param['id'] === 'RCC') {
                    _this.openConsent();
                    _this.router.navigate(['/client-report/', 'ED']);
                }
                else if (param['id'] === 'AITE') {
                    _this.openTaxConsent();
                }
                else if (param['id'] === 'AP') {
                    _this.openAssetProfile();
                }
                _this.RouterLog = param['id'];
            }
            else {
                if (param['id'] === 'AITE') {
                    _this.openTaxConsent();
                }
                else {
                    _this.router.navigate(['/client-report/', 'ED']);
                }
                _this.RouterLog = param['id'];
            }
        });
    };
    ClientReportComponent.prototype.TimeCountLogOut = function () {
        var _this = this;
        this.timeLogout = this.timeLogout + 1;
        if (this.timeLogout === 900 && sessionStorage.getItem("LoginSuccess") === 'Y') {
            this.clickLogout();
        }
        else {
            setTimeout(function () { _this.TimeCountLogOut(); }, 1000);
        }
    };
    ClientReportComponent.prototype.checkAgentID = function () {
        this.AgentID = sessionStorage.getItem('AgentID');
        if (this.AgentID == 1) {
            this.isOne = true;
        }
        else {
            this.isOne = false;
        }
    };
    ClientReportComponent.prototype.goDownloadPage = function () {
        this.router.navigate(['/download-form']);
    };
    ClientReportComponent.prototype.checkLogin = function () {
        var _this = this;
        if (this.personalID === '' || this.personalID === undefined) {
            this.pidReq = true;
            this.showPDPA = false;
            this.requestOTP = false;
            this.loginError = this.language.cs_pid;
        }
        else {
            this.loader.start();
            this.pidReq = false;
            this.otpReq = false;
            // check pid and send otp
            this.mainService.GetDataRequest(this.personalID).subscribe(function (params) {
                console.log(params);
                if (params['ErrorCode'] == '401') {
                    _this.loginError = _this.language.ed_loging_error_401;
                    _this.loginError = _this.language.ed_loging_error_401;
                    _this.pidReq = true;
                    _this.otpReq = true;
                    _this.loader.stop();
                }
                else if (params['ErrorCode'] == '404') {
                    _this.loginError = _this.language.ed_login_error_404;
                    _this.loginError = _this.language.ed_login_error_404;
                    _this.pidReq = true;
                    _this.otpReq = true;
                    _this.loader.stop();
                }
                else {
                    _this.route.params.subscribe(function (param) {
                        _this.RouterLog = (param['id'] == 'AITE') ? param['id'] : "";
                    });
                    sessionStorage.setItem('CType', params['VerifyPIDNo']);
                    sessionStorage.setItem('cusid', params['Result'][0]['CustomerId']);
                    _this.mainService.checkCustomerPID(_this.personalID, 'mobileOTP', 'W').subscribe(function (response) {
                        if (response['Success'] === true) {
                            if (params['VerifyPIDNo'] == false && _this.RouterLog == 'AITE') {
                                $('#warningModalForClientReport').modal('show');
                            }
                            _this.refOTP = response['Result'];
                            _this.otpMsg = response['Message'];
                            _this.otpError = '';
                            _this.showLogin = false;
                            _this.showPDPA = false;
                            // if found pid then send otp
                            _this.requestOTP = true;
                            _this.AgentID = response['Agent'];
                            if (params['VerifyPIDNo'] == false && _this.RouterLog == 'AITE') {
                                _this.router.navigate(['/client-report/', 'ED']);
                            }
                        }
                        else {
                            _this.pidReq = true;
                            _this.otpReq = true;
                            if (response['Message'] == '405') {
                                _this.loginError = _this.language.ed_login_error_405;
                                _this.otpError = _this.language.ed_login_error_405;
                            }
                            else if (response['Message'] == '404') {
                                _this.loginError = _this.language.ed_login_error_404;
                                _this.otpError = _this.language.ed_login_error_404;
                            }
                            else if (response['Message'] == '403') {
                                _this.loginError = _this.language.ed_login_error_403;
                                _this.otpError = _this.language.ed_login_error_403;
                            }
                            else if (response['Message'] == '402') {
                                _this.loginError = _this.language.ed_login_error_402;
                                _this.otpError = _this.language.ed_login_error_402;
                            }
                            // this.loginError = response['Message'];
                            // this.otpError = response['Message'];
                        }
                    });
                    _this.loader.stop();
                    _this.isVerifyPIDNo = params['VerifyPIDNo'];
                }
            });
        }
    };
    ClientReportComponent.prototype.checkOTP = function () {
        var _this = this;
        if (this.inputOTP === '' || this.inputOTP === undefined) {
            this.otpReq = true;
            this.showPDPA = false;
            this.otpError = this.language.cs_otp;
        }
        else {
            this.loader.start();
            // check OTP
            this.otpReq = false;
            this.otpError = this.language.cs_otp;
            // if correct otp then
            this.mainService.checkCustomerOTP(this.personalID, 'mobileOTP', 'W', this.refOTP, this.inputOTP).subscribe(function (response) {
                if (response['Success'] === true) {
                    _this.uid = response['Message'];
                    _this.showPDPA = true;
                    _this.requestOTP = false;
                    _this.loginSeccess = true;
                    sessionStorage.setItem('LoginSuccess', 'Y');
                    _this.Login(_this.personalID, _this.uid, _this.AgentID);
                    _this.checkSevice();
                }
                else {
                    if (response['Message'] == '101') {
                        _this.otpError = _this.language.ed_otp_error_103;
                    }
                    else if (response['Message'] == '102') {
                        _this.otpError = _this.language.ed_otp_error_102;
                    }
                    _this.otpReq = true;
                    _this.requestOTP = true;
                }
            });
            this.loader.stop();
        }
    };
    ClientReportComponent.prototype.getOTPTitle = function () {
        return this.language.cs_otp_title + '(Ref : ' + this.refOTP + ') ' + this.otpMsg + this.language.cs_otp_title2;
    };
    ClientReportComponent.prototype.openDSAR = function () {
        // window.open('https://privacyportal-apac.onetrust.com/webform/fbb17504-0994-4d1e-9ede-8617a50a50eb/draft/f5fa2705-9819-49b9-a52d-44a770554214');
        window.open('https://privacyportal-apac.onetrust.com/webform/fbb17504-0994-4d1e-9ede-8617a50a50eb/04521887-a33d-46e1-a5f1-de880a450ab9');
    };
    ClientReportComponent.prototype.openConsent = function () {
        var _this = this;
        this.loader.start();
        var cusid = sessionStorage.getItem('id');
        this.mainService.loadConsent(cusid, sessionStorage.getItem('PIDNo')).subscribe(function (response) {
            _this.consentDesc = response['Purposes'];
            $('#ucModal').modal({ backdrop: 'static', keyboard: false });
            _this.loader.stop();
        });
    };
    ClientReportComponent.prototype.closeCovidModal = function () {
        var _this = this;
        var data = [];
        this.consentDesc.forEach(function (e) {
            if (e['TransactionType'] === 'ACTIVE') {
                e['TransactionType'] = null;
            }
            var consentObj = { Id: e['Id'], TransactionType: e['TransactionType'] };
            data.push(consentObj);
        });
        this.loader.start();
        this.mainService.sendConsent(sessionStorage.getItem('PIDNo'), data).subscribe(function (response) {
            _this.loader.stop();
            $('#ucModal').modal('hide');
        });
    };
    ClientReportComponent.prototype.onChangeConsent = function (item) {
        if (item.TransactionType === 'ACTIVE') {
            item.TransactionType = 'WITHDRAWN';
        }
        else {
            item.TransactionType = 'ACTIVE';
        }
    };
    ClientReportComponent.prototype.Login = function (pid, id, agentID) {
        var login = document.getElementById('click-Login');
        var sectionlogin = document.getElementById('client-report-Login-On');
        if (sectionlogin.style.display === 'none') {
            sectionlogin.style.display = 'block';
            login.style.display = 'none';
        }
        this.getDataCustomer(pid);
        this.saveMyStorage(pid, id, agentID);
        this.timeLogout = 0;
        this.TimeCountLogOut();
        this.checkAgentID();
    };
    ClientReportComponent.prototype.clickLogout = function () {
        this.loader.start();
        if (this.router.url === '/client-report/ED') {
            var sectionlogin = document.getElementById('client-report-Login-On');
            var login = document.getElementById('click-Login');
            if (sectionlogin != null && login != null) {
                if (login.style.display === 'none') {
                    login.style.display = 'block';
                    sectionlogin.style.display = 'none';
                }
            }
            this.ResetCard();
        }
        else {
            this.timeLogout = 0;
        }
        this.clearMystorageLogin();
        location.reload();
        this.loader.stop();
    };
    ClientReportComponent.prototype.getDataCustomer = function (pid) {
        var _this = this;
        this.loader.start();
        if (pid === null) {
            this.loader.stop();
        }
        else {
            this.mainService.GetDataRequest(pid).subscribe(function (params) {
                if (params['Result'] == null) {
                    alert("กรุณาติดต่อหน่วยงานลูกค้าสัมพันธ์ โทร. 02-659-8888 กด 1");
                }
                else {
                    _this.customer_id = params['Result'][0]['CustomerId'];
                    sessionStorage.setItem('cusid', _this.customer_id);
                    // if(this.language_flag == 'th'){
                    //     this.customer_Name = params['Result'][0]['CustomerName'];
                    // }
                    _this.customerNameArry = params['Result'][0]['CustomerName'].split(',');
                    _this.customer_Name = _this.customerNameArry[1];
                    _this.customer_Name_En = _this.customerNameArry[3];
                    _this.customer_title_name_En = _this.customerNameArry[2];
                    if (_this.customerNameArry[0] === 'นาย' || _this.customerNameArry[0] === 'นาง' || _this.customerNameArry[0] === 'นางสาว') {
                        _this.customer_title_name = 'คุณ';
                    }
                    else {
                        _this.customer_title_name = _this.customerNameArry[0];
                    }
                    _this.fundList = params['Result'][0]['FundList'];
                    _this.fundList = _this.fundList.sort(function (a, b) { return (a.FundCode > b.FundCode) ? 1 : -1; });
                    _this.HolderNostr = params['Result'][0]['HolderNo'];
                    _this.HolderNo = _this.HolderNostr.split(',');
                    _this.HolderNo = _this.HolderNo.sort(function (a, b) { return (a > b ? -1 : 1); });
                    _this.HolderNo.forEach(function (element, index) {
                        if (element === '') {
                            _this.HolderNo.splice(index, 1);
                        }
                    });
                }
                _this.loader.stop();
            });
        }
    };
    ClientReportComponent.prototype.BackOneYear = function () {
        var get_months = (new Date().getMonth());
        while (this.monthListTH.length < 12) {
            if (this.language_flag !== 'th') {
                this.monthListTH.push(this.checkmonth[get_months]['nameEn']);
            }
            else {
                this.monthListTH.push(this.checkmonth[get_months]['name']);
            }
            get_months = get_months + 1;
            if (get_months == 12) {
                get_months = 0;
            }
        }
    };
    ClientReportComponent.prototype.backFiveYear = function () {
        var get_Year = (new Date().getFullYear());
        var startDateCount = new Date(get_Year, 0, 16);
        var countDate = 1;
        if (new Date() < startDateCount) {
            countDate = countDate + 1;
        }
        if (this.language_flag !== 'th') {
            for (countDate; countDate <= 5; countDate++) {
                this.year101.push((get_Year - countDate));
            }
        }
        else {
            for (countDate; countDate <= 5; countDate++) {
                this.year101.push((get_Year - countDate) + 543);
            }
        }
    };
    ClientReportComponent.prototype.saveMyStorage = function (pid, id, agentID) {
        var time = new Date();
        var time2 = new Date(time);
        sessionStorage.setItem('PIDNo', pid);
        sessionStorage.setItem('id', id);
        sessionStorage.setItem('AgentID', agentID);
        time2.setMinutes(time.getMinutes() + this.TimeLogoutDate);
        sessionStorage.setItem('TimeLogout', JSON.stringify([time2.getHours(), time2.getMinutes(), time2.getDay()]));
    };
    ClientReportComponent.prototype.checkTimeOut = function (timeout) {
        var time = new Date();
        var time2 = new Date(time);
        if (time.getHours() > timeout[0] && time.getMinutes() <= timeout[1]) {
            return true;
        }
        else if (time.getHours() >= timeout[0] && time.getMinutes() >= timeout[1]) {
            return true;
        }
        else if (time.getDay() != timeout[2] || time.getDay() !== timeout[2]) {
            return true;
        }
        else {
            return false;
        }
    };
    ClientReportComponent.prototype.loadMyStorage = function (pid, id, agentID, timeout, verifyPid, cusid) {
        if (pid !== null || id !== null || agentID !== null) {
            if (this.checkTimeOut(timeout) == true) {
                this.clickLogout();
            }
            else {
                this.customer_id = cusid;
                this.PidNo = pid;
                this.isVerifyPIDNo = verifyPid;
                this.Login(pid, id, agentID);
                this.checkAgentID();
            }
        }
    };
    ClientReportComponent.prototype.clearMystorageLogin = function () {
        sessionStorage.removeItem('PIDNo');
        sessionStorage.removeItem('id');
        sessionStorage.removeItem('AgentID');
        sessionStorage.removeItem('LoginSuccess');
        sessionStorage.removeItem('TimeLogout');
        sessionStorage.removeItem('CType');
        sessionStorage.removeItem('cusid');
    };
    ClientReportComponent.prototype.dowloadReport = function (temcod, holderno, date, fundlists) {
        var _this = this;
        this.loader.start();
        this.timeLogout = 0;
        this.mainService.downloadFilePdf(temcod, holderno, date, fundlists).subscribe(function (response) {
            if (response === "Not Found") {
                alert("ไม่พบไฟล์รายงาน");
            }
            else {
                var linkSource = 'data:application/pdf;base64,' + response;
                var downloadLink = document.createElement('a');
                _this.nameFilePdf();
                var fileName = temcod + _this.customer_id + _this.toDay;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
            _this.loader.stop();
        });
    };
    ClientReportComponent.prototype.dowlondHolderReport = function () {
        this.loader.start();
        var inputMonth = document.getElementById("selectMonth");
        var inputHolderNo = document.getElementById("selectHolderNo");
        var dateMonth = "0";
        for (var i = 0; i <= 11; i++) {
            if (this.checkmonth[i]['name'] === inputMonth.value || this.checkmonth[i]['nameEn'] === inputMonth.value) {
                dateMonth = String(this.checkmonth[i]['number']);
            }
        }
        if (inputHolderNo.value === 'HolderAll') {
            this.dowloadReport('RPT107', this.HolderNostr, dateMonth, this.fundList);
        }
        else {
            this.dowloadReport('RPT107', inputHolderNo.value, dateMonth, this.fundList);
        }
    };
    ClientReportComponent.prototype.downloadReportConfimation = function () {
        this.selectFundList = [];
        var inputFundList = document.getElementById('selectfundListRPT106');
        var inputHolderNo = document.getElementById('selectHolderNoRPT106');
        this.loader.start();
        var fundListlLngth = this.fundList.length;
        for (var i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT106', this.HolderNostr, '0', this.fundList);
        }
        else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
            this.dowloadReport('RPT106', this.HolderNostr, '0', this.selectFundList);
        }
        else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT106', inputHolderNo.value, '0', this.fundList);
        }
        else {
            this.dowloadReport('RPT106', inputHolderNo.value, '0', this.selectFundList);
        }
    };
    ClientReportComponent.prototype.downloadReportPurchase = function () {
        this.loader.start();
        this.selectFundList = [];
        var inputFundList = document.getElementById('selectfundListRPT101');
        var inputHolderNo = document.getElementById('selectHolderNoRPT101');
        var inputDateYear = document.getElementById('selectDateYearRPT101');
        var fundListlLngth = this.fundList.length;
        var yearTH = parseInt(inputDateYear.value) - 543;
        for (var i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (this.language_flag === 'th') {
            if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, yearTH.toString(), this.fundListfilter);
            }
            else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, yearTH.toString(), this.selectFundList);
            }
            else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', inputHolderNo.value, yearTH.toString(), this.fundListfilter);
            }
            else {
                this.dowloadReport('RPT101', inputHolderNo.value, yearTH.toString(), this.selectFundList);
            }
        }
        else {
            if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, inputDateYear.value, this.fundListfilter);
            }
            else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, inputDateYear.value, this.selectFundList);
            }
            else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', inputHolderNo.value, inputDateYear.value, this.fundListfilter);
            }
            else {
                this.dowloadReport('RPT101', inputHolderNo.value, inputDateYear.value, this.selectFundList);
            }
        }
    };
    ClientReportComponent.prototype.downloadReportRedemption = function () {
        this.loader.start();
        this.selectFundList = [];
        var inputFundList = document.getElementById('selectfundListRPT102');
        var inputHolderNo = document.getElementById('selectHolderNoRPT102');
        var fundListlLngth = this.fundList.length;
        for (var i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT102', this.HolderNostr, '0', this.fundListfilter);
        }
        else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
            this.dowloadReport('RPT102', this.HolderNostr, '0', this.selectFundList);
        }
        else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT102', inputHolderNo.value, '0', this.fundListfilter);
        }
        else {
            this.dowloadReport('RPT102', inputHolderNo.value, '0', this.selectFundList);
        }
    };
    ClientReportComponent.prototype.downloadReportTransfer = function () {
        this.loader.start();
        this.selectFundList = [];
        var inputFundList = document.getElementById('selectfundListRPT103');
        var inputHolderNo = document.getElementById('selectHolderNoRPT103');
        var fundListlLngth = this.fundList.length;
        for (var i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT103', this.HolderNostr, '0', this.fundListfilter);
        }
        else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
            this.dowloadReport('RPT103', this.HolderNostr, '0', this.selectFundList);
        }
        else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT103', inputHolderNo.value, '0', this.fundListfilter);
        }
        else {
            this.dowloadReport('RPT103', inputHolderNo.value, '0', this.selectFundList);
        }
    };
    ClientReportComponent.prototype.nameFilePdf = function () {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        var hh = String(today.getHours()).padStart(2, '0');
        var mimi = String(today.getMinutes()).padStart(2, '0');
        var ssss = String(today.getSeconds()).padStart(2, '0');
        this.toDay = dd + mm + yyyy + hh + mimi + ssss;
    };
    ClientReportComponent.prototype.selectAllTest = function (elemholder, elemfund, but) {
        this.timeLogout = 0;
        var selecthol = document.getElementById(elemholder);
        var selectfund = document.getElementById(elemfund);
        var butt = document.getElementById(but);
        var Year101 = document.getElementById('selectDateYearRPT101');
        var fundLength = this.fundList.length;
        this.fundListfilter = [];
        var myArry = [];
        var checkboxlength = this.checkBoxList.length;
        var selectAll = this.checkBoxSelectall[0]['isChecked'];
        if (selectAll === true) {
            for (var i = 0; i < checkboxlength; i++) {
                this.checkBoxList[i]['isChecked'] = true;
            }
            this.select_fund = this.typeFundList;
            this.selectCount = this.typeFundList.length;
            ;
            if (this.select_fund[this.select_fund.length - 1] === 'SSFX') {
                for (var l = 0; l < fundLength; l++) {
                    var mySSFX = this.fundList[l]['FundCode'];
                    myArry = mySSFX.split('-');
                    if (myArry[myArry.length - 1] === this.select_fund[this.select_fund.length - 1] || this.fundList[l]['FundTypeGroup'] !== null) {
                        if (myArry[myArry.length - 1] === this.select_fund[this.select_fund.length - 1]) {
                            this.fundList[l]['FundTypeGroup'] = 'SSFX';
                        }
                        this.fundListfilter.push(this.fundList[l]);
                    }
                }
            }
            else {
                for (var l = 0; l < fundLength; l++) {
                    var mySSFX = this.fundList[l]['FundCode'];
                    myArry = mySSFX.split('-');
                    if (this.fundList[l]['FundTypeGroup'] !== null && myArry[myArry.length - 1] !== 'SSFX') {
                        this.fundListfilter.push(this.fundList[l]);
                    }
                }
            }
            this.fundListfilter = this.fundListfilter.sort(function (a, b) { return (a.FundCode > b.FundCode) ? 1 : -1; });
            selecthol.disabled = false;
            selectfund.disabled = false;
            butt.disabled = false;
            Year101.disabled = false;
        }
        else if (selectAll === false) {
            for (var i = 0; i < checkboxlength; i++) {
                this.checkBoxList[i]['isChecked'] = false;
            }
            this.selectCount = 0;
            this.select_fund = [];
            selecthol.disabled = true;
            selectfund.disabled = true;
            butt.disabled = true;
            Year101.disabled = true;
        }
    };
    ClientReportComponent.prototype.ResetCard = function () {
        this.select_fund = [];
        this.fundListfilter = [];
        this.timeLogout = 0;
        var checkboxlength = this.checkBoxList.length;
        this.checkBoxSelectall[0]['isChecked'] = false;
        for (var i = 0; i < checkboxlength; i++) {
            this.checkBoxList[i]['isChecked'] = false;
        }
        this.clearRPT101();
        this.clearRPT102();
        this.clearRPT103();
        this.clearRPT106();
        this.clearRPT107();
        this.selectCount = 0;
    };
    ClientReportComponent.prototype.selectTest = function (elemholder, elemfund, but) {
        var checkboxlength = this.checkBoxList.length;
        this.timeLogout = 0;
        var _loop_1 = function (i) {
            var val = this_1.checkBoxList[i]['Name'];
            val = (val === 'ThaiESG') ? 'TESG' : val;
            var valcheck = this_1.checkBoxList[i]['isChecked'];
            var found = this_1.select_fund.find(function (element) { return element === val; });
            var foundIndex = this_1.select_fund.indexOf(val);
            if (valcheck === true && found === undefined) {
                this_1.select_fund.push(val);
                this_1.AddFundListTest(val, elemholder, elemfund, but);
                this_1.selectCount += 1;
            }
            else if (valcheck === false && found !== undefined) {
                this_1.select_fund.splice(foundIndex, 1);
                this_1.RemoveFundListTest(val);
                this_1.selectCount -= 1;
            }
            console.log(this_1.selectCount);
            if (this_1.selectCount === this_1.typeFundList.length) {
                this_1.checkBoxSelectall[0]['isChecked'] = true;
            }
            else {
                this_1.checkBoxSelectall[0]['isChecked'] = false;
            }
        };
        var this_1 = this;
        for (var i = 0; i < checkboxlength; i++) {
            _loop_1(i);
        }
        var selecthol = document.getElementById(elemholder);
        var selectfund = document.getElementById(elemfund);
        var butt = document.getElementById(but);
        var Year101 = document.getElementById('selectDateYearRPT101');
        if (this.selectCount === 0) {
            selecthol.disabled = true;
            selectfund.disabled = true;
            butt.disabled = true;
            Year101.disabled = true;
        }
        else if (this.selectCount > 0) {
            selecthol.disabled = false;
            selectfund.disabled = false;
            butt.disabled = false;
            Year101.disabled = false;
        }
        if (this.selectCount > this.typeFundList.length) {
            this.selectCount = this.typeFundList.length;
        }
    };
    ClientReportComponent.prototype.AddFundListTest = function (val, elemholder, elemfund, but) {
        var fundLength = this.fundList.length;
        var myArry = [];
        if (val === 'SSFX') {
            for (var l = 0; l < fundLength; l++) {
                var mySSFX = this.fundList[l]['FundCode'];
                myArry = mySSFX.split('-');
                if (myArry[myArry.length - 1] === val) {
                    this.fundList[l]['FundTypeGroup'] = 'SSFX';
                    this.fundListfilter.push(this.fundList[l]);
                }
            }
        }
        else {
            for (var l = 0; l < fundLength; l++) {
                var mySSFX = this.fundList[l]['FundCode'];
                myArry = mySSFX.split('-');
                if (this.fundList[l]['FundTypeGroup'] === val && myArry[myArry.length - 1] !== 'SSFX') {
                    this.fundListfilter.push(this.fundList[l]);
                }
            }
        }
        this.fundListfilter = this.fundListfilter.sort(function (a, b) { return (a.FundCode > b.FundCode) ? 1 : -1; });
        var selecthol = document.getElementById(elemholder);
        var selectfund = document.getElementById(elemfund);
        var butt = document.getElementById(but);
        var Year101 = document.getElementById('selectDateYearRPT101');
        selecthol.disabled = false;
        selectfund.disabled = false;
        butt.disabled = false;
        Year101.disabled = false;
    };
    ClientReportComponent.prototype.RemoveFundListTest = function (val) {
        var fundListTransferlenght = this.fundListfilter.length;
        for (var l = 0; l < fundListTransferlenght; l++) {
            if (this.fundListfilter[l]['FundTypeGroup'] === val) {
                this.fundListfilter.splice(l, 1);
                fundListTransferlenght = this.fundListfilter.length;
                l = l - 1;
            }
        }
    };
    // ===================================================clearAndRemoveFunction==========================================================//
    ClientReportComponent.prototype.clearRPT101 = function () {
        var selecthol101 = document.getElementById('selectHolderNoRPT101');
        var selectfund101 = document.getElementById('selectfundListRPT101');
        var butt101 = document.getElementById('but101');
        var holderno101 = document.getElementById('selectHolderNoRPT101');
        var Year101 = document.getElementById('selectDateYearRPT101');
        holderno101.value = 'HolderNoAll';
        selecthol101.disabled = true;
        selectfund101.disabled = true;
        butt101.disabled = true;
        Year101.disabled = true;
        Year101.value = this.year101[0];
    };
    ClientReportComponent.prototype.clearRPT102 = function () {
        var holderno102 = document.getElementById('selectHolderNoRPT102');
        var selecthol102 = document.getElementById('selectHolderNoRPT102');
        var selectfund102 = document.getElementById('selectfundListRPT102');
        var butt102 = document.getElementById('but102');
        holderno102.value = 'HolderNoAll';
        selecthol102.disabled = true;
        selectfund102.disabled = true;
        butt102.disabled = true;
    };
    ClientReportComponent.prototype.clearRPT103 = function () {
        var selecthol103 = document.getElementById('selectHolderNoRPT103');
        var selectfund103 = document.getElementById('selectfundListRPT103');
        var butt103 = document.getElementById('butTransfer');
        var holderno103 = document.getElementById('selectHolderNoRPT103');
        selecthol103.disabled = true;
        selectfund103.disabled = true;
        butt103.disabled = true;
        holderno103.value = 'HolderNoAll';
    };
    ClientReportComponent.prototype.clearRPT106 = function () {
        var holderno106 = document.getElementById('selectHolderNoRPT106');
        var fundlist106 = document.getElementById('selectfundListRPT106');
        fundlist106.value = 'fundListAll';
        holderno106.value = 'HolderNoAll';
    };
    ClientReportComponent.prototype.clearRPT107 = function () {
        var mouth107 = document.getElementById('selectMonth');
        var holderno107 = document.getElementById('selectHolderNo');
        holderno107.value = 'HolderAll';
        mouth107.value = this.monthListTH[0];
    };
    ClientReportComponent.prototype.openTaxConsent = function () {
        if (this.isVerifyPIDNo == false) {
            $('#warningModalForClientReport').modal('show');
        }
        else {
            this.router.navigate(['/tax-consent']);
        }
    };
    ClientReportComponent.prototype.userAgree = function () {
        $('#warningModalForClientReport').modal('hide');
    };
    ClientReportComponent.prototype.checkClient_passport = function () {
        $('#warningModalForClientReport').modal('show');
        this.router.navigate(['/client-report/', 'ED']);
    };
    ClientReportComponent.prototype.openAssetProfile = function () {
        this.router.navigate(['/asset-profile']);
    };
    return ClientReportComponent;
}());
export { ClientReportComponent };
